<p-dialog header="AI Testdaten generieren"
          [(visible)]="visible"
          (visibleChange)="visibleChange.emit($event)"
          [modal]="true"
          [style]="{width: '700px'}"
          [closable]="true"
          (onHide)="close()">

    <div class="flex flex-column gap-3 mt-3">
        <div class="flex align-items-center justify-content-between">
            <span class="text-500">Template ID: {{templateId}}</span>
            <p-button label="Generieren"
                      icon="fa-regular fa-brain"
                      (click)="generate()"
                      [disabled]="loading"
                      [outlined]="true">
            </p-button>
        </div>

        @if (loading) {
            <div class="flex justify-content-center p-5">
                <p-progressSpinner styleClass="w-3rem h-3rem" animationDuration=".5s"></p-progressSpinner>
            </div>
        } @else if (scenarios.length > 0) {
            @for (scenario of scenarios; track scenario.testCaseName) {
                <div class="surface-50 border-round p-3">
                    <div class="flex align-items-center justify-content-between mb-2">
                        <div class="flex align-items-center gap-2">
                            <i [class]="getScenarioIcon(scenario.scenario)"></i>
                            <span class="font-medium">{{scenario.testCaseName}}</span>
                            <p-tag [value]="getScenarioLabel(scenario.scenario)" severity="info" styleClass="text-xs"></p-tag>
                        </div>
                        <p-button label="Anwenden"
                                  icon="fa-regular fa-check"
                                  (click)="applyScenario(scenario)"
                                  [disabled]="applying"
                                  [outlined]="true"
                                  size="small">
                        </p-button>
                    </div>

                    <p-table [value]="scenario.variables" [scrollable]="true" scrollHeight="200px" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Variable</th>
                                <th>Typ</th>
                                <th>Wert</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-variable>
                            <tr>
                                <td><code>{{variable.alias}}</code></td>
                                <td><p-tag [value]="variable.type" [severity]="variable.type === 'object' ? 'info' : 'secondary'" styleClass="text-xs"></p-tag></td>
                                <td>
                                    @if (variable.simpleValue) {
                                        {{variable.simpleValue}}
                                    } @else {
                                        <span class="text-500">Object #{{variable.objectId}}</span>
                                    }
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            }
        } @else {
            <div class="text-center text-500 p-5">
                <i class="fa-regular fa-flask text-4xl mb-2"></i>
                <p>Klicken Sie auf "Generieren", um AI-Testdaten zu erstellen.</p>
            </div>
        }
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Schlie&szlig;en" [text]="true" (click)="close()"></p-button>
    </ng-template>
</p-dialog>
